var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 130.479C105.875 130.479 130.5 105.903 130.5 75.4795C130.5 45.0563 105.875 20.4795 75.5 20.4795C45.1252 20.4795 20.5 45.0563 20.5 75.4795C20.5 105.903 45.1252 130.479 75.5 130.479Z",
    fill: "#F3F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2364 45.9708C57.2419 44.553 55.6188 43.709 53.8871 43.709H40.3788C35.5785 43.709 31.859 47.9069 32.437 52.6722L35.8965 81.1958C36.3837 85.2122 39.7926 88.2326 43.8383 88.2326H104.876C108.937 88.2326 112.354 85.1901 112.823 81.1564L115.613 57.1564C116.165 52.404 112.45 48.2326 107.666 48.2326H62.5857C60.8539 48.2326 59.2309 47.3885 58.2364 45.9708Z",
    fill: "url(#paint0_linear_512_24765)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.002 53.0297C108.13 53.0297 101.474 53.0297 89.6024 53.0297C86.6024 53.0297 83.8024 54.0297 81.5024 55.9297L73.5024 62.4297C71.3024 64.2297 68.4024 65.3297 65.4024 65.3297H31.0024C27.5024 65.3297 24.7024 68.2297 24.7024 71.6297C24.7024 71.9297 24.7024 72.2297 24.8024 72.5297L31.1024 106.23C31.6024 109.43 34.3024 111.73 37.4024 111.73H111.002C114.202 111.73 116.802 109.53 117.302 106.33L126.202 60.2297C126.802 56.7297 124.502 53.6297 121.002 52.9297C120.702 53.0297 120.302 53.0297 120.002 53.0297Z",
    fill: "url(#paint1_linear_512_24765)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.834 34.9639C80.4213 34.9639 82.5186 32.8666 82.5186 30.2793C82.5186 27.6921 80.4213 25.5947 77.834 25.5947C75.2468 25.5947 73.1494 27.6921 73.1494 30.2793C73.1494 32.8666 75.2468 34.9639 77.834 34.9639Z",
    fill: "#D2D6D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.753 83.2003C53.3402 83.2003 55.4376 81.1029 55.4376 78.5157C55.4376 75.9284 53.3402 73.8311 50.753 73.8311C48.1657 73.8311 46.0684 75.9284 46.0684 78.5157C46.0684 81.1029 48.1657 83.2003 50.753 83.2003Z",
    fill: "#CCD2D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3782 38.5777C30.6698 38.5777 32.5275 36.7201 32.5275 34.4285C32.5275 32.137 30.6698 30.2793 28.3782 30.2793C26.0867 30.2793 24.229 32.137 24.229 34.4285C24.229 36.7201 26.0867 38.5777 28.3782 38.5777Z",
    fill: "#E6E9EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5132 17.1748C50.7698 17.1748 51.7886 16.1561 51.7886 14.8994C51.7886 13.6427 50.7698 12.624 49.5132 12.624C48.2565 12.624 47.2378 13.6427 47.2378 14.8994C47.2378 16.1561 48.2565 17.1748 49.5132 17.1748Z",
    fill: "#E6E9EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9333 10.5508C91.19 10.5508 92.2087 9.53204 92.2087 8.27538C92.2087 7.01872 91.19 6 89.9333 6C88.6767 6 87.658 7.01872 87.658 8.27538C87.658 9.53204 88.6767 10.5508 89.9333 10.5508Z",
    fill: "#E6E9EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.157 46.5871C125.153 46.5871 126.771 44.9691 126.771 42.9732C126.771 40.9773 125.153 39.3594 123.157 39.3594C121.161 39.3594 119.543 40.9773 119.543 42.9732C119.543 44.9691 121.161 46.5871 123.157 46.5871Z",
    fill: "#E6E9EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.186 97.1945C104.182 97.1945 105.8 95.5765 105.8 93.5806C105.8 91.5848 104.182 89.9668 102.186 89.9668C100.19 89.9668 98.5725 91.5848 98.5725 93.5806C98.5725 95.5765 100.19 97.1945 102.186 97.1945Z",
    fill: "#C5CBCF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_24765",
    x1: 74.2912,
    y1: 38.6873,
    x2: 74.2912,
    y2: 77.6263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C5C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_24765",
    x1: 75.4668,
    y1: 51.5696,
    x2: 75.4668,
    y2: 112.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#DEE2E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.eac6e3e83788bb416558039475613ae2.svg";
export { ForwardRef as ReactComponent };